<!--
 * @Author: qinmengyuan
 * @Date: 2024-08-16 14:50:08
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-08-21 16:50:35
 * @FilePath: \onetab\src\components\ShareCancelModal.vue
-->
<template>
  <RaDialog
    width="400px"
    :model-value="visible"
    :before-close="handleClose"
    :append-to-body="true"
    class="cancel-modal"
    title="取消分享"
  >
    <div class="container">
      <div class="desc">
        <RaIcon icon="TipsExclamationCircleFill"></RaIcon>
        确认取消分享当前选择的记录吗？
      </div>
      <div class="text">
        取消分享后，分享记录将被删除，好友将无法再访问分享链接。
      </div>
    </div>
    <div class="btns">
      <RaButton
        type="neutral"
        status="secondary"
        class="btn"
        @click="emits('close')"
        >取消</RaButton
      >
      <RaButton type="danger" class="btn" status="main" @click="handleCancel"
        >确定取消分享</RaButton
      >
    </div>
  </RaDialog>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import {
  RaDialog,
  RaInput,
  RaCheckboxGroup,
  RaCheckbox,
  RaMessage,
  RaButton,
} from '@rafter/pc';
import { RaIcon } from '@rafter/icon';
import { deleteShare } from '@/api/baseApi';
const emits = defineEmits(['close']);
const inputValue = ref('');
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: '',
  },
});
watch(
  () => props.visible,
  () => {
    if (props.visible) {
      inputValue.value = props.value;
    }
  }
);
const handleCancel = async () => {
  console.log('取消分享');
  deleteShare(props.value)
    .then((res) => {
      console.log(res);
      if (res.data.code === 200) {
        RaMessage.success('删除成功');
      } else {
        RaMessage.error('操作失败');
      }
    })
    .catch(() => {
      RaMessage.error('操作失败');
    })
    .finally(() => {
      emits('close', true);
    });
};
const handleClose = () => {
  emits('close');
};
</script>
<style lang="scss">
.cancel-modal {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  border-radius: 24px !important;
  min-height: 224px !important;
  @include background_color('base-bg-color-09');
  backdrop-filter: blur(40px);
  .ra-dialog__header {
    padding: 16px 24px !important;
    .ra-dialog__title {
      @include font_color('text-on-surface-primary');
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
    }
  }
  .ra-dialog__body {
    padding: 0 24px !important;
    display: flex;
    flex-direction: column;
    .container {
      display: flex;
      gap: 12px;
      flex-direction: column;
      flex: 1;
    }
    .desc {
      @include font_color('text-on-surface-primary');
      /* web/cn/heading/heading-01 */
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 157.143% */
      letter-spacing: 0.5px;
      display: flex;
      align-items: center;
      gap: 8px;
      i {
        font-size: 22px;
        color: rgba(253, 120, 35, 1);
      }
    }
    .text {
      @include font_color('text-on-surface-primary');
      margin-left: 30px;
      /* web/cn/helper/helper-03 */
      font-family: 'PingFang SC';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 153.846% */
      letter-spacing: 0.4px;
    }
  }
  .btns {
    display: flex;
    padding: 20px 0;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 16px;
    align-self: stretch;
    .btn {
      width: 106px;
    }
  }
}
</style>
